import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
  stepFive(filter: $filter) {
    default_colors {
        id
        name
        hex_code
        number
        code
    }
    colors {
        id
        name
        hex_code
        number
        code
    }
    feature_sets {
        id
        name
        order_no
        feature {
            id
            name
            order_no
        }
    }
  }
}`;